<app-job-notification-card
  (closeEvent)="onCloseClickedHandler()"
  [jobNotification]="spreadsheetExportNotificationCard"
  [notificationIcon]="'svg_excel'"
>
  <div notification-action-button>
    <app-print-action-buttons
      (downloadSpreadsheetButtonClickedEvent)="downloadSpreadsheetButtonClickedHandler()"
      [downloadSpreadsheetFlag]="true"
      [downloadSpreadsheetLabel]="
        spreadsheetExportNotificationCard.multipleFilesFlag ? 'Télécharger le fichier Zip' : 'Télécharger le fichier Excel'
      "
      class="floating-action-buttons"
    ></app-print-action-buttons>
  </div>
</app-job-notification-card>
